import { render, staticRenderFns } from "./RipaNodeTree.vue?vue&type=template&id=98d1f13a"
import script from "./RipaNodeTree.vue?vue&type=script&lang=js"
export * from "./RipaNodeTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports